/* @flow */
import Vue from 'vue'

import {REMOVE_SESSION} from './session'

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const REPLACE_NOTIFICATION = 'REPLACE_NOTIFICATION'

export const NEW_NOTIFICATION = 'NEW_NOTIFICATION'

const initialState = () => ({
  idForNextNotification: 1,
  entities: {},
})

export default {
  state: initialState(),
  getters: {
    nextNotification: (state: Object) => {
      const nextId = Object.keys(state.entities)
        .map(key => parseInt(key))
        .sort()[0]
      return state.entities[nextId]
    },
    notificationToShow: (state: Object) => !!Object.keys(state.entities).length,
  },
  mutations: {
    RESET_STATE() {
      // Don't reset state here, because it would erase app update notifications
    },
    [REMOVE_SESSION](state: Object) {
      state.entities = initialState().entities
    },
    [ADD_NOTIFICATION](state: Object, payload: Object) {
      state.entities = {
        ...state.entities,
        [payload.id]: payload,
      }
      state.idForNextNotification += 1
    },
    [REMOVE_NOTIFICATION](state: Object, payload: Object) {
      Vue.delete(state.entities, payload.id)
    },
    [REPLACE_NOTIFICATION](state: Object, payload: Object) {
      if (payload.id) {
        state.entities[payload.id] = payload
      } else {
        state.entities = {
          ...state.entities,
          [state.idForNextNotification]: {
            ...payload,
            id: state.idForNextNotification,
          },
        }
        state.idForNextNotification += 1
      }
    },
  },
  actions: {
    [REMOVE_NOTIFICATION]({commit, state, rootState}: Object, payload: Object) {
      commit(REMOVE_NOTIFICATION, payload)
      return
    },
    [NEW_NOTIFICATION]({commit, state, rootState}: Object, payload: Object) {
      // Only show errors if logged in. This keeps odd errors from showing that happened because
      // user wasn't logged in
      if (payload.bypassLoginCheck || rootState.session.authToken) {
        payload.id = state.idForNextNotification
        commit(ADD_NOTIFICATION, payload)
        return payload.id
      }

      // eslint-disable-next-line no-console
      console.log('Not queing notification because user not logged in')
      return
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/notifications.js